import type { PortableTextListComponent } from '@portabletext/react';

const NumberList: PortableTextListComponent = ({ children }) => (
  <ol className="my-6 list-decimal pl-8 first:mt-0 md:pl-12">{children}</ol>
);

export default NumberList;

export const NumberListHtml: PortableTextListComponent = ({ children }) => (
  <ol>{children}</ol>
);
